export default class Location {
    public locationId!: number;
    public description!: string;
    public active!: boolean;

    constructor(init?: Partial<Location>) {
        Object.assign(this, init);
    }

}